// Merrily brand fallbacks. These mirror what the hosted Console branding asset
// serves today (coral #e06b52, the Merrily wordmark, the Merrily social image)
// so the local fallback is HONEST — if the mergeBranding overwrite in
// configHelpers.js is ever removed, the site stays Merrily instead of reverting
// to the Biketribe template. Console stays authoritative; this is
// fallback-correction only (no precedence change).
import merrilyLogo from '../assets/merrily-logo.png';
import brandImage from '../assets/rte-brandImage-1500.jpg';
import facebookImage from '../assets/merrily-facebook-sharing.png';
import twitterImage from '../assets/merrily-twitter-sharing.png';

/////////////////////////////////////////////////////////
// This file contains configs that affect branding     //
// NOTE: these are just some of the relevant configs   //
// Most of the work happens in marketplaceDefaults.css //
// and in components.                                  //
/////////////////////////////////////////////////////////

// Note: These come from the branding asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeBranding func)

// Marketplace color.
// This is saved as CSS Property: --marketplaceColor in src/app.js
// Also --marketplaceColorDark and --marketplaceColorLight are generated from this one
// by adding +/- 10% to lightness.
export const marketplaceColor = '#e06b52';

// Logo is used in Topbar on mobile and desktop, where height is the limiting factor.
// Therefore, we strongly suggest that your image file for desktop logo is in landscape!
//
// If you need to fine-tune the logo, the component is defined in src/components/Logo/Logo.js
// By default logo gets 24 pixels vertical space, but it could be wider (e.g. 180px)
// The default images are meant for retina displays and are therefore twice as big in actual dimensions
// One Merrily wordmark for both desktop + mobile. Note: the *visible*
// topbar/footer logo is the custom SVG in components/Logo/Logo.js — these image
// URLs only feed the SEO/structured-data logo (Page.js) as a fallback when the
// hosted Console logo asset is unset.
export const logoImageDesktopURL = merrilyLogo;
export const logoImageMobileURL = merrilyLogo;

// The _logoSettings_ settings for the logo. Due to constraints in current Topbar, we only support 3 height variants
// at this point. There could be more height variants in the future and potentially other logo formats than 'image'.
// Note: logo image is always scaled and the limiting factor is height. However, there's also maximum width,
//       which is 370px in the Topbar. If the logo is wider than that, browser will scale it down.
export const logoSettings = {
  height: 24, // Hosted asset supports: 24, 36, 48
  format: 'image',
};

// brandImageURL is used as a background image on the "hero" section of several pages.
// Used on AuthenticationPage, EmailVerificationPage, PasswordRecoveryPage, PasswordResetPage etc.
// NOTE: Those pages use ResponsiveBackgroundImageContainer component,
//       it's possible to include more image variants to make image fetching more performant.
export const brandImageURL = brandImage;

// Default images for social media sharing
// These can be overwritten per page

// For Facebook, the aspect ratio should be 1200x630 (otherwise, the image is cropped)
export const facebookImageURL = facebookImage;
// For Twitter, the aspect ratio should be 600x314 (otherwise, the image is cropped)
export const twitterImageURL = twitterImage;
